 export async function processEmissionData(finalPayload, hierarchialData, selectedUIAllFilters) {
    let uniqueEmiRecords = [];
    const subCategory3 = finalPayload?.category_level3;
    const subCategory2 = finalPayload?.category_level2;
    const subCategory1 = finalPayload?.category_level1;
    let hierarchyData = hierarchialData;
    let scopevalue = finalPayload?.scope;
    let filteredByScopeArray = hierarchyData?.filter((element) =>
        scopevalue?.includes(element.scope)
    );
    if (!selectedUIAllFilters?.scope?.length) {
        if (subCategory3?.length === 1 && subCategory3[0] === "N/A") {
            if (subCategory2?.length === 1 && subCategory2[0] === "N/A") {
                if (subCategory1?.length === 1 && subCategory1[0] === "N/A") {
                    let record = {
                        scope: scopevalue[0],
                        category_level1: "",
                        category_level2: "",
                        category_level3: "",
                    };
                    uniqueEmiRecords?.push(record);
                } else {
                    subCategory1.forEach((value) => {
                        let index = filteredByScopeArray?.findIndex(
                            (element) =>
                                element?.category_level1 === value &&
                                scopevalue?.includes(element.scope)
                        );
                        let record = {
                            scope: scopevalue[0],
                            category_level1: filteredByScopeArray[index]["category_level1"],
                            category_level2: filteredByScopeArray[index]["category_level2"],
                            category_level3: filteredByScopeArray[index]["category_level3"],
                            entity_level1: filteredByScopeArray[index]["entity_level1"],
                            entity_level2: filteredByScopeArray[index]["entity_level2"],
                            entity_level3: filteredByScopeArray[index]["entity_level3"],
                            entity_level4: filteredByScopeArray[index]["entity_level4"],
                            region_level1: filteredByScopeArray[index]["region_level1"],
                            region_level2: filteredByScopeArray[index]["region_level2"],
                            region_level3: filteredByScopeArray[index]["region_level3"],
                        };
                        uniqueEmiRecords?.push(record);
                    });
                }
            } else {
                subCategory2.forEach((value) => {
                    if (value !== "N/A") {
                        let index = filteredByScopeArray.findIndex(
                            (element) =>
                                element.category_level2 === value &&
                                scopevalue.includes(element.scope)
                        );
                        let record = {
                            scope: filteredByScopeArray[index]["scope"],
                            category_level1: filteredByScopeArray[index]["category_level1"],
                            category_level2: filteredByScopeArray[index]["category_level2"],
                            category_level3: filteredByScopeArray[index]["category_level3"],
                            entity_level1: filteredByScopeArray[index]["entity_level1"],
                            entity_level2: filteredByScopeArray[index]["entity_level2"],
                            entity_level3: filteredByScopeArray[index]["entity_level3"],
                            entity_level4: filteredByScopeArray[index]["entity_level4"],
                            region_level1: filteredByScopeArray[index]["region_level1"],
                            region_level2: filteredByScopeArray[index]["region_level2"],
                            region_level3: filteredByScopeArray[index]["region_level3"],
                        };
                        uniqueEmiRecords.push(record);
                    }
                });
            }
        } else {
            subCategory3?.forEach((value) => {
                for (let i = 0; i < filteredByScopeArray.length; i++) {
                    if (
                        value === filteredByScopeArray[i].category_level3 &&
                        scopevalue?.includes(filteredByScopeArray[i].scope) &&
                        subCategory1?.includes(filteredByScopeArray[i].category_level1) &&
                        subCategory2?.includes(filteredByScopeArray[i].category_level2)
                    ) {
                        let record = {
                            scope: filteredByScopeArray[i].scope,
                            category_level1: filteredByScopeArray[i].category_level1,
                            category_level2: filteredByScopeArray[i].category_level2,
                            category_level3: value,
                            region_level1: filteredByScopeArray[i].region_level1,
                            region_level2: filteredByScopeArray[i].region_level2,
                            region_level3: filteredByScopeArray[i].region_level3,
                            entity_level1: filteredByScopeArray[i]["entity_level1"],
                            entity_level2: filteredByScopeArray[i]["entity_level2"],
                            entity_level3: filteredByScopeArray[i]["entity_level3"],
                            entity_level4: filteredByScopeArray[i]["entity_level4"],
                            custom_specification1:
                                filteredByScopeArray[i]["custom_specification1"],
                            custom_specification2:
                                filteredByScopeArray[i]["custom_specification2"],
                            custom_specification3:
                                filteredByScopeArray[i]["custom_specification3"],
                        };
                        uniqueEmiRecords.push(record);
                    }
                }
            });
        }
    } else {
        filteredByScopeArray = hierarchyData?.filter((element) =>
            selectedUIAllFilters?.scope.includes(element.scope)
        );
        selectedUIAllFilters?.category_level3?.forEach((value) => {
            for (let i = 0; i < filteredByScopeArray.length; i++) {
                if (
                    value === filteredByScopeArray[i].category_level3 &&
                    selectedUIAllFilters?.scope?.includes(filteredByScopeArray[i].scope) &&
                    selectedUIAllFilters?.category_level1.includes(
                        filteredByScopeArray[i].category_level1
                    ) &&
                    selectedUIAllFilters?.category_level2?.includes(
                        filteredByScopeArray[i].category_level2
                    )
                ) {
                    let record = {
                        scope: filteredByScopeArray[i].scope,
                        category_level1: filteredByScopeArray[i].category_level1,
                        category_level2: filteredByScopeArray[i].category_level2,
                        category_level3: value,
                        region_level1: filteredByScopeArray[i].region_level1,
                        region_level2: filteredByScopeArray[i].region_level2,
                        region_level3: filteredByScopeArray[i].region_level3,
                        entity_level1: filteredByScopeArray[i]["entity_level1"],
                        entity_level2: filteredByScopeArray[i]["entity_level2"],
                        entity_level3: filteredByScopeArray[i]["entity_level3"],
                        entity_level4: filteredByScopeArray[i]["entity_level4"],
                        custom_specification1:
                            filteredByScopeArray[i]["custom_specification1"],
                        custom_specification2:
                            filteredByScopeArray[i]["custom_specification2"],
                        custom_specification3:
                            filteredByScopeArray[i]["custom_specification3"],
                    };
                    uniqueEmiRecords.push(record);
                }
            }
        });
    }
    return uniqueEmiRecords;
}

export async function processRegionData(finalPayload, hierarchialData, selectedUIAllFilters) {
    let uniqueRecords = [];

    const subRegion3 = finalPayload?.region_level3;
    const subRegion2 = finalPayload?.region_level2;
    const subRegion1 = finalPayload?.region_level1;

    let hierarchyData = hierarchialData;
    let scopevalue = finalPayload?.scope;
    let filteredByScopeArray = hierarchyData?.filter((element) =>
        scopevalue?.includes(element.scope)
    );
    if (!selectedUIAllFilters?.scope?.length) {
        if (subRegion3?.length === 1 && subRegion3[0] === "N/A") {
            if (subRegion2?.length === 1 && subRegion2[0] === "N/A") {
                if (subRegion1?.length === 1 && subRegion1[0] === "N/A") {
                    let record = {
                        scope: scopevalue[0],
                        region_level1: "",
                        region_level2: "",
                        region_level3: ""
                    };
                    uniqueRecords?.push(record);
                } else {
                    subRegion1?.forEach((value) => {
                        let index = filteredByScopeArray?.findIndex(
                            (element) => element?.region_level1 === value);

                        let record = {
                            scope: scopevalue[0],
                            category_level1: filteredByScopeArray[index]["category_level1"],
                            category_level2: filteredByScopeArray[index]["category_level2"],
                            category_level3: filteredByScopeArray[index]["category_level3"],
                            entity_level1: filteredByScopeArray[index]["entity_level1"],
                            entity_level2: filteredByScopeArray[index]["entity_level2"],
                            entity_level3: filteredByScopeArray[index]["entity_level3"],
                            entity_level4: filteredByScopeArray[index]["entity_level4"],
                            region_level1: filteredByScopeArray[index]["region_level1"],
                            region_level2: filteredByScopeArray[index]["region_level2"],
                            region_level3: filteredByScopeArray[index]["region_level3"],
                        };
                        uniqueRecords?.push(record);
                    });
                }
            } else {
                subRegion2?.forEach((value) => {
                    if (value !== "N/A") {
                        let index = filteredByScopeArray.findIndex(
                            (element) => element.region_level2 === value);

                        if (index !== -1) {
                            let record = {
                                scope: filteredByScopeArray[index]["scope"],
                                category_level1: filteredByScopeArray[index]["category_level1"],
                                category_level2: filteredByScopeArray[index]["category_level2"],
                                category_level3: filteredByScopeArray[index]["category_level3"],
                                entity_level1: filteredByScopeArray[index]["entity_level1"],
                                entity_level2: filteredByScopeArray[index]["entity_level2"],
                                entity_level3: filteredByScopeArray[index]["entity_level3"],
                                entity_level4: filteredByScopeArray[index]["entity_level4"],
                                region_level1: filteredByScopeArray[index]["region_level1"],
                                region_level2: filteredByScopeArray[index]["region_level2"],
                                region_level3: filteredByScopeArray[index]["region_level3"],
                            };
                            uniqueRecords.push(record);
                        }
                    }
                });
            }
        } else {
            subRegion3?.forEach((value) => {
                for (let i = 0; i < filteredByScopeArray.length; i++) {
                    if (
                        value === filteredByScopeArray[i].region_level3 &&
                        scopevalue?.includes(filteredByScopeArray[i].scope) &&
                        subRegion1?.includes(filteredByScopeArray[i].region_level1) &&
                        subRegion2?.includes(filteredByScopeArray[i].region_level2)
                    ) {
                        let record = {
                            scope: filteredByScopeArray[i].scope,
                            category_level1: filteredByScopeArray[i].category_level1,
                            category_level2: filteredByScopeArray[i].category_level2,
                            category_level3: filteredByScopeArray[i].category_level3,
                            region_level1: filteredByScopeArray[i].region_level1,
                            region_level2: filteredByScopeArray[i].region_level2,
                            region_level3: filteredByScopeArray[i].region_level3,
                            entity_level1: filteredByScopeArray[i]["entity_level1"],
                            entity_level2: filteredByScopeArray[i]["entity_level2"],
                            entity_level3: filteredByScopeArray[i]["entity_level3"],
                            entity_level4: filteredByScopeArray[i]["entity_level4"],
                            custom_specification1:
                                filteredByScopeArray[i]["custom_specification1"],
                            custom_specification2:
                                filteredByScopeArray[i]["custom_specification2"],
                            custom_specification3:
                                filteredByScopeArray[i]["custom_specification3"],
                        };
                        uniqueRecords.push(record);
                    }
                }
            });
        }
    } else {
        filteredByScopeArray = hierarchyData.filter((element) =>
            selectedUIAllFilters?.scope.includes(element.scope)
        );
        selectedUIAllFilters?.region_level3?.forEach((value) => {
            for (let i = 0; i < filteredByScopeArray.length; i++) {
                if (
                    value === filteredByScopeArray[i].region_level3 &&
                    selectedUIAllFilters?.scope.includes(filteredByScopeArray[i].scope) &&
                    selectedUIAllFilters?.region_level1.includes(
                        filteredByScopeArray[i].region_level1
                    ) &&
                    selectedUIAllFilters?.region_level2.includes(
                        filteredByScopeArray[i].region_level2
                    )
                ) {
                    let record = {
                        scope: filteredByScopeArray[i].scope,
                        category_level1: filteredByScopeArray[i].category_level1,
                        category_level2: filteredByScopeArray[i].category_level2,
                        category_level3: filteredByScopeArray[i].category_level3,
                        region_level1: filteredByScopeArray[i].region_level1,
                        region_level2: filteredByScopeArray[i].region_level2,
                        region_level3: filteredByScopeArray[i].region_level3,
                        entity_level1: filteredByScopeArray[i]["entity_level1"],
                        entity_level2: filteredByScopeArray[i]["entity_level2"],
                        entity_level3: filteredByScopeArray[i]["entity_level3"],
                        entity_level4: filteredByScopeArray[i]["entity_level4"],
                        custom_specification1:
                            filteredByScopeArray[i]["custom_specification1"],
                        custom_specification2:
                            filteredByScopeArray[i]["custom_specification2"],
                        custom_specification3:
                            filteredByScopeArray[i]["custom_specification3"],
                    };
                    uniqueRecords.push(record);
                }
            }
        });
    }

    return uniqueRecords;
}

export async function processCustomData(finalPayload, hierarchialData, selectedUIAllFilters) {
    let uniqueRecords = [];

    const subCustom3 = finalPayload?.custom_specification3;
    const subCustom2 = finalPayload?.custom_specification2;
    const subCustom1 = finalPayload?.custom_specification1;

    let hierarchyData = hierarchialData;
    let scopevalue = finalPayload?.scope;
    let filteredByScopeArray = hierarchyData?.filter((element) =>
        scopevalue?.includes(element.scope)
    );

    if (!selectedUIAllFilters?.scope?.length) {
        subCustom3?.forEach((value) => {
            if (value !== "N/A") {
                for (let i = 0; i < filteredByScopeArray?.length; i++) {
                    if (
                        value === filteredByScopeArray[i]?.custom_specification3 &&
                        scopevalue?.includes(filteredByScopeArray[i].scope) &&
                        subCustom1?.includes(
                            filteredByScopeArray[i]?.custom_specification1
                        ) &&
                        subCustom2?.includes(
                            filteredByScopeArray[i]?.custom_specification2
                        )
                    ) {
                        let record = {
                            scope: filteredByScopeArray[i]?.scope,
                            category_level1: filteredByScopeArray[i]?.category_level1,
                            category_level2: filteredByScopeArray[i]?.category_level2,
                            category_level3: filteredByScopeArray[i]?.category_level3,
                            region_level1: filteredByScopeArray[i]?.region_level1,
                            region_level2: filteredByScopeArray[i]?.region_level2,
                            region_level3: filteredByScopeArray[i]?.region_level3,
                            entity_level1: filteredByScopeArray[i]["entity_level1"],
                            entity_level2: filteredByScopeArray[i]["entity_level2"],
                            entity_level3: filteredByScopeArray[i]["entity_level3"],
                            entity_level4: filteredByScopeArray[i]["entity_level4"],
                            custom_specification1:
                                filteredByScopeArray[i]["custom_specification1"],
                            custom_specification2:
                                filteredByScopeArray[i]["custom_specification2"],
                            custom_specification3:
                                filteredByScopeArray[i]["custom_specification3"],
                        };
                        uniqueRecords.push(record);
                    }
                }
            }
        });
    } else {
        filteredByScopeArray = hierarchyData.filter((element) =>
            selectedUIAllFilters?.scope?.includes(element.scope)
        );
        selectedUIAllFilters?.custom_specification3?.forEach((value) => {
            if (value !== "N/A") {
                for (let i = 0; i < filteredByScopeArray.length; i++) {
                    if (
                        value === filteredByScopeArray[i].region_level3 &&
                        selectedUIAllFilters?.scope?.includes(filteredByScopeArray[i].scope) &&
                        selectedUIAllFilters.custom_specification1.includes(
                            filteredByScopeArray[i].custom_specification1
                        ) &&
                        selectedUIAllFilters.custom_specification2.includes(
                            filteredByScopeArray[i].custom_specification2
                        )
                    ) {
                        let record = {
                            scope: filteredByScopeArray[i].scope,
                            category_level1: filteredByScopeArray[i].category_level1,
                            category_level2: filteredByScopeArray[i].category_level2,
                            category_level3: filteredByScopeArray[i].category_level3,
                            region_level1: filteredByScopeArray[i].region_level1,
                            region_level2: filteredByScopeArray[i].region_level2,
                            region_level3: filteredByScopeArray[i].region_level3,
                            entity_level1: filteredByScopeArray[i]["entity_level1"],
                            entity_level2: filteredByScopeArray[i]["entity_level2"],
                            entity_level3: filteredByScopeArray[i]["entity_level3"],
                            entity_level4: filteredByScopeArray[i]["entity_level4"],
                            custom_specification1:
                                filteredByScopeArray[i]["custom_specification1"],
                            custom_specification2:
                                filteredByScopeArray[i]["custom_specification2"],
                            custom_specification3:
                                filteredByScopeArray[i]["custom_specification3"],
                        };
                        uniqueRecords.push(record);
                    }
                }
            }
        });
    }
    return uniqueRecords;
}

export async function processOrgData(finalPayload, hierarchialData, selectedUIAllFilters) {
    let uniqueRecords = [];

    const subOrg3 = finalPayload?.entity_level3;
    const subOrg2 = finalPayload?.entity_level2;
    const subOrg1 = finalPayload?.entity_level1;
    const subOrg4 = finalPayload?.entity_level4;

    let hierarchyData = hierarchialData;
    let scopevalue = finalPayload?.scope;
    let filteredByScopeArray = hierarchyData?.filter((element) =>
        scopevalue?.includes(element.scope)
    );
    if (!selectedUIAllFilters?.scope?.length) {
        if (subOrg3?.length === 1 && subOrg3[0] === "N/A") {
            if (subOrg2?.length === 1 && subOrg2[0] === "N/A") {
                if (subOrg1?.length === 1 && subOrg1[0] === "N/A") {
                    let record = {
                        scope: scopevalue[0],
                        entity_level1: "",
                        entity_level2: "",
                        entity_level3: "",
                        entity_level4: "",
                    };
                    uniqueRecords?.push(record);
                } else {
                    subOrg1?.forEach((value) => {
                        let index = filteredByScopeArray?.findIndex(
                            (element) => element?.entity_level1 === value);
                        if (index !== -1) {
                            let record = {
                                scope: scopevalue[0],
                                category_level1: filteredByScopeArray[index]["category_level1"],
                                category_level2: filteredByScopeArray[index]["category_level2"],
                                category_level3: filteredByScopeArray[index]["category_level3"],
                                entity_level1: filteredByScopeArray[index]["entity_level1"],
                                entity_level2: filteredByScopeArray[index]["entity_level2"],
                                entity_level3: filteredByScopeArray[index]["entity_level3"],
                                entity_level4: filteredByScopeArray[index]["entity_level4"],
                                region_level1: filteredByScopeArray[index]["region_level1"],
                                region_level2: filteredByScopeArray[index]["region_level2"],
                                region_level3: filteredByScopeArray[index]["region_level3"],
                            };
                            uniqueRecords?.push(record);
                        }
                    });
                }
            } else {
                subOrg2?.forEach((value) => {
                    if (value !== "N/A") {
                        let index = filteredByScopeArray.findIndex(
                            (element) => element.entity_level2 === value);
                        if (index !== -1) {
                            let record = {
                                scope: filteredByScopeArray[index]["scope"],
                                category_level1: filteredByScopeArray[index]["category_level1"],
                                category_level2: filteredByScopeArray[index]["category_level2"],
                                category_level3: filteredByScopeArray[index]["category_level3"],
                                entity_level1: filteredByScopeArray[index]["entity_level1"],
                                entity_level2: filteredByScopeArray[index]["entity_level2"],
                                entity_level3: filteredByScopeArray[index]["entity_level3"],
                                entity_level4: filteredByScopeArray[index]["entity_level4"],
                                region_level1: filteredByScopeArray[index]["region_level1"],
                                region_level2: filteredByScopeArray[index]["region_level2"],
                                region_level3: filteredByScopeArray[index]["region_level3"],
                            };
                            uniqueRecords.push(record);
                        }
                    }
                });
            }
        } else {
            subOrg3?.forEach((value) => {
                for (let i = 0; i < filteredByScopeArray.length; i++) {
                    if (
                        value === filteredByScopeArray[i].entity_level3 &&
                        scopevalue?.includes(filteredByScopeArray[i].scope) &&
                        subOrg1?.includes(filteredByScopeArray[i].entity_level1) &&
                        subOrg2?.includes(filteredByScopeArray[i].entity_level2)
                    ) {
                        let record = {
                            scope: filteredByScopeArray[i].scope,
                            category_level1: filteredByScopeArray[i].category_level1,
                            category_level2: filteredByScopeArray[i].category_level2,
                            category_level3: filteredByScopeArray[i].category_level3,
                            region_level1: filteredByScopeArray[i].region_level1,
                            region_level2: filteredByScopeArray[i].region_level2,
                            region_level3: filteredByScopeArray[i].region_level3,
                            entity_level1: filteredByScopeArray[i]["entity_level1"],
                            entity_level2: filteredByScopeArray[i]["entity_level2"],
                            entity_level3: filteredByScopeArray[i]["entity_level3"],
                            entity_level4: filteredByScopeArray[i]["entity_level4"],
                            custom_specification1:
                                filteredByScopeArray[i]["custom_specification1"],
                            custom_specification2:
                                filteredByScopeArray[i]["custom_specification2"],
                            custom_specification3:
                                filteredByScopeArray[i]["custom_specification3"],
                        };
                        uniqueRecords.push(record);
                    }
                }
            });
        }
    } else {
        filteredByScopeArray = hierarchyData.filter((element) =>
            selectedUIAllFilters?.scope.includes(element.scope)
        );
        selectedUIAllFilters?.entity_level3?.forEach((value) => {
            for (let i = 0; i < filteredByScopeArray.length; i++) {
                if (
                    value === filteredByScopeArray[i]?.entity_level3 &&
                    selectedUIAllFilters?.scope?.includes(filteredByScopeArray[i]?.scope) &&
                    selectedUIAllFilters?.entity_level1?.includes(
                        filteredByScopeArray[i]?.entity_level1
                    ) &&
                    selectedUIAllFilters?.entity_level2?.includes(
                        filteredByScopeArray[i]?.entity_level2
                    )
                ) {
                    let record = {
                        scope: filteredByScopeArray[i].scope,
                        category_level1: filteredByScopeArray[i].category_level1,
                        category_level2: filteredByScopeArray[i].category_level2,
                        category_level3: filteredByScopeArray[i].category_level3,
                        region_level1: filteredByScopeArray[i].region_level1,
                        region_level2: filteredByScopeArray[i].region_level2,
                        region_level3: filteredByScopeArray[i].region_level3,
                        entity_level1: filteredByScopeArray[i]["entity_level1"],
                        entity_level2: filteredByScopeArray[i]["entity_level2"],
                        entity_level3: filteredByScopeArray[i]["entity_level3"],
                        entity_level4: filteredByScopeArray[i]["entity_level4"],
                        custom_specification1:
                            filteredByScopeArray[i]["custom_specification1"],
                        custom_specification2:
                            filteredByScopeArray[i]["custom_specification2"],
                        custom_specification3:
                            filteredByScopeArray[i]["custom_specification3"],
                    };
                    uniqueRecords.push(record);
                }
            }
        });
    }
    return uniqueRecords;
}

export async function handleAllpayload(
    type, 
    finalPayload, 
    selectedUIAllFilters, 
    hierarchialData, 
) {
    let array = [];
    let filteredByScopeArray = [];
    if (selectedUIAllFilters?.scope) {
        filteredByScopeArray = hierarchialData.filter((element) =>
            selectedUIAllFilters?.scope.includes(element.scope)
        );
    } else {
        filteredByScopeArray = hierarchialData.filter((element) =>
            finalPayload?.scope?.includes(element.scope)
        );
    }
    let scopeArr = [];
    let categoryLevelObj = {};
    let orgLevelObj = {};
    let regionLevelObj = {};
    let customLevelObj = {};
    if (selectedUIAllFilters?.scope) {
        scopeArr = selectedUIAllFilters?.scope;
    } else {
        scopeArr = finalPayload?.scope;
    }
    if (type === 'Emission') {
        scopeArr?.forEach((scope) => {
            for (let i = 0; i < filteredByScopeArray?.length; i++) {
                if (scope === filteredByScopeArray[i]?.scope) {
                    categoryLevelObj = {
                        category_level1: filteredByScopeArray[i]?.category_level1 
                            ? filteredByScopeArray[i]?.category_level1 
                            : "All",
                        category_level2: filteredByScopeArray[i]?.category_level2 
                            ? filteredByScopeArray[i]?.category_level2 
                            : "All",
                        category_level3: filteredByScopeArray[i]?.category_level3 
                            ? filteredByScopeArray[i]?.category_level3 
                            : "All",
                    };
                    let record = getRecord(scope, filteredByScopeArray, i, categoryLevelObj, type);
                    array.push(record);
                }
            }
        });
    }

    if (type === 'Organisational') {
        scopeArr?.forEach((scope) => {
            for (let i = 0; i < filteredByScopeArray?.length; i++) {
                if (scope === filteredByScopeArray[i]?.scope) {
                    orgLevelObj = {
                        entity_level1: filteredByScopeArray[i]?.entity_level1 
                            ? filteredByScopeArray[i]?.entity_level1 
                            : "All",
                        entity_level2: filteredByScopeArray[i]?.entity_level2 
                            ? filteredByScopeArray[i]?.entity_level2 
                            : "All",
                        entity_level3: filteredByScopeArray[i]?.entity_level3 
                            ? filteredByScopeArray[i]?.entity_level3 
                            : "All",
                        entity_level4: filteredByScopeArray[i]?.entity_level4 
                            ? filteredByScopeArray[i]?.entity_level4 
                            : "All",
                    };
                    let record = getRecord(scope, filteredByScopeArray, i, orgLevelObj, type);
                    array.push(record);
                }
            }
        });
    }

    if (type === 'Regional') {
        scopeArr?.forEach((scope) => {
            for (let i = 0; i < filteredByScopeArray?.length; i++) {
                if (scope === filteredByScopeArray[i]?.scope) {
                    regionLevelObj = {
                        region_level1: filteredByScopeArray[i]?.region_level1
                            ? filteredByScopeArray[i]?.region_level1
                            : "All",
                        region_level2: filteredByScopeArray[i]?.region_level2
                            ? filteredByScopeArray[i]?.region_level2
                            : "All",
                        region_level3: filteredByScopeArray[i]?.region_level3
                            ? filteredByScopeArray[i]?.region_level3
                            : "All",
                    };
                    let record = getRecord(scope, filteredByScopeArray, i, regionLevelObj, type);
                    array.push(record);
                }
            }
        });
    }

    if (type === 'Custom') {
        scopeArr?.forEach((scope) => {
            for (let i = 0; i < filteredByScopeArray?.length; i++) {
                if (scope === filteredByScopeArray[i]?.scope) {
                    customLevelObj = {
                        custom_specification1: filteredByScopeArray[i]?.custom_specification1
                            ? filteredByScopeArray[i]?.custom_specification1
                            : "All",
                        custom_specification2: filteredByScopeArray[i]?.custom_specification2
                            ? filteredByScopeArray[i]?.custom_specification2
                            : "All",
                        custom_specification3: filteredByScopeArray[i]?.custom_specification3
                            ? filteredByScopeArray[i]?.custom_specification3
                            : "All",
                    };
                    let record = getRecord(scope, filteredByScopeArray, i, customLevelObj, type);
                    array.push(record);
                }
            }
        });
    }

    return array;
}

const getRecord = (scope, filteredByScopeArray, i, levelObj, type) => {
    if (type === 'Emission') {
        return {
            scope: scope,
            category_level1: levelObj?.category_level1,
            category_level2: levelObj?.category_level2,
            category_level3: levelObj?.category_level3,
            region_level1: filteredByScopeArray[i].region_level1,
            region_level2: filteredByScopeArray[i].region_level2,
            region_level3: filteredByScopeArray[i].region_level3,
            entity_level1: filteredByScopeArray[i]["entity_level1"],
            entity_level2: filteredByScopeArray[i]["entity_level2"],
            entity_level3: filteredByScopeArray[i]["entity_level3"],
            entity_level4: filteredByScopeArray[i]["entity_level4"],
            custom_specification1:
                filteredByScopeArray[i]["custom_specification1"],
            custom_specification2:
                filteredByScopeArray[i]["custom_specification2"],
            custom_specification3:
                filteredByScopeArray[i]["custom_specification3"],
        };
    }
    if (type === 'Organisational') {
        return {
            scope: scope,
            category_level1: filteredByScopeArray[i]?.category_level1,
            category_level2: filteredByScopeArray[i]?.category_level2,
            category_level3: filteredByScopeArray[i]?.category_level3,
            region_level1: filteredByScopeArray[i].region_level1,
            region_level2: filteredByScopeArray[i].region_level2,
            region_level3: filteredByScopeArray[i].region_level3,
            entity_level1: levelObj?.entity_level1,
            entity_level2: levelObj?.entity_level2,
            entity_level3: levelObj?.entity_level3,
            entity_level4: levelObj?.entity_level4,
            custom_specification1:
                filteredByScopeArray[i]["custom_specification1"],
            custom_specification2:
                filteredByScopeArray[i]["custom_specification2"],
            custom_specification3:
                filteredByScopeArray[i]["custom_specification3"],
        };
    }
    if (type === 'Regional') {
        return {
            scope: scope,
            category_level1: filteredByScopeArray[i]?.category_level1,
            category_level2: filteredByScopeArray[i]?.category_level2,
            category_level3: filteredByScopeArray[i]?.category_level3,
            region_level1: levelObj?.region_level1,
            region_level2: levelObj?.region_level2,
            region_level3: levelObj?.region_level3,
            entity_level1: filteredByScopeArray[i]?.entity_level1,
            entity_level2: filteredByScopeArray[i]?.entity_level2,
            entity_level3: filteredByScopeArray[i]?.entity_level3,
            entity_level4: filteredByScopeArray[i]?.entity_level4,
            custom_specification1:
                filteredByScopeArray[i]["custom_specification1"],
            custom_specification2:
                filteredByScopeArray[i]["custom_specification2"],
            custom_specification3:
                filteredByScopeArray[i]["custom_specification3"],
        };
    }
    if (type === 'Custom') {
        return {
            scope: scope,
            category_level1: filteredByScopeArray[i]?.category_level1,
            category_level2: filteredByScopeArray[i]?.category_level2,
            category_level3: filteredByScopeArray[i]?.category_level3,
            region_level1: filteredByScopeArray[i]?.region_level1,
            region_level2: filteredByScopeArray[i]?.region_level2,
            region_level3: filteredByScopeArray[i]?.region_level3,
            entity_level1: filteredByScopeArray[i]?.entity_level1,
            entity_level2: filteredByScopeArray[i]?.entity_level2,
            entity_level3: filteredByScopeArray[i]?.entity_level3,
            entity_level4: filteredByScopeArray[i]?.entity_level4,
            custom_specification1: levelObj?.custom_specification1,
            custom_specification2: levelObj?.custom_specification2,
            custom_specification3: levelObj?.custom_specification3,
        };
    }
}